import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Title class.
 */
export default class Rosace extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Rosace',
  };

  /**
   *
   */
  mounted() {
    gsap.to(this.$el, {
      ease: 'none',
      rotate: -30,
      scrollTrigger: {
        trigger: this.$el,
        start: 'top bottom',
        end: '+=100% top',
        scrub: true,
      },
    });
  }
}
